// extracted by mini-css-extract-plugin
export default {"outer":"outer-FVfaWQ4t","container":"container-u52N19bE","top":"top-gitemY2y","left":"left-Dp9o9pHb"};